import { BottomTabBar } from '../components/BottomTabBar';

import '@styles/MainLayout.css';

export const MainLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="main-layout">
      <div className="main-content">
        {children}
      </div>
      <BottomTabBar />
    </div>
  );
};
